import * as React from 'react';

// Utils
import { times } from '@src/shared/src/util/general';
// Constants
// Actions
// Models
import { HotelModel } from '@src/shared/src/models';
// Interfaces
// Components
import HotelFavoriteButton from './HotelFavoriteButton';

// Styles
import '../styles/HotelTitle.scss';

type Props = {
  hotel: HotelModel;
};

const HotelTitle: React.FC<Props> = ({ hotel }) => {
  const hotelStars = times(
    (idx) => <span key={`star-${idx}`} className="icon-star" />,
    hotel.comfortClass === -1 ? 0 : hotel.comfortClass,
  );

  return (
    <div className="tcp-hotel-title">
      <div className="tcp-hotel-title-wrapper">
        <div className="tcp-hotel-title-name-stars">
          <h2 className="tcp-hotel-title-name">{hotel.name}</h2>
          {hotelStars.length > 0 && <div className="tcp-hotel-title-stars">{hotelStars}</div>}
        </div>
        <HotelFavoriteButton hotelId={hotel.id} isFavorite={hotel.favorited} />
      </div>
      <div className="tcp-hotel-title-location">
        <i className="icon-walk" />
        &nbsp;{hotel.distance} km&nbsp;-&nbsp;
        <span className="tcp-hotel-title-location-address">{hotel.address}</span>
      </div>
    </div>
  );
};

export default HotelTitle;
